import AspApi from './ApiConfig';

export const Logout = async () =>
  await AspApi.post('api/v1/svc/aaa/authentication/logout');

export const currentUserDetails = async () =>
  await AspApi.get('api/v1/svc/aaa/authentication/current_user');

export const currentBrandWhatsappConnected = async (brandId) =>
  await AspApi.get(`/api/v1/channels/validate?brand_id=${brandId}`);

export const preSendUrl = async (extensionName, payload) => {
  let qpm = [];
  if (payload?.brand_id) qpm.push(`brand_id=${payload?.brand_id}`);

  switch (payload?.path) {
    case 'meta-template':
      qpm.push(`path=${payload?.path}`);
      qpm.push(`template_id=${payload?.template_id}`);
      break;
    case 'inbox':
      qpm.push(`path=${payload?.path}`);
      qpm.push(`phone_number=${payload?.phone_number}`);
      break;
    case 'web-chat-icon':
    case 'data-sources':
      qpm.push(`path=${payload?.path}`);
      break;
    case 'products':
      qpm.push(`path=${payload?.path}`);
      break;
    case 'flow':
      qpm.push(`path=${payload?.path}`);
      if (payload?.flow_id) {
        qpm.push(`flow_id=${payload.flow_id}`);
      }
      break;
    default:
      break;
  }

  if (payload?.file_name) qpm.push(`file_name=${payload?.file_name}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString += '&' + qpm?.join('&');

  const res = await AspApi.get(
    `api/v1/svc/aaa/presigned_url?extension_name=${extensionName}${qpmString}`,
  );
  return res;
};

export const preSendingUrl = async (params) =>
  await AspApi.get(`api/v1/svc/aaa/presigned_url?extension_name=${params}`);

export const crmPreSendingUrl = async (params, payload) => {
  let qpm = [];
  if (payload?.brand_id) qpm.push(`brand_id=${payload?.brand_id}`);
  if (payload?.extension_name)
    qpm.push(`extension_name=${payload?.extension_name}`);
  if (payload?.path) qpm.push(`path=${payload?.path}`);

  let qpmString = '';
  if (qpm?.length > 0) qpmString += '&' + qpm?.join('&');

  const res = await AspApi.get(
    `api/v1/svc/aaa/presigned_url?extension_name=${params}${qpmString}`,
  );
  return res;
};

export const whatsappBusinessNumbers = async (brandId) => {
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/whatsapp_numbers?brand_id=${brandId}`,
  );
  return res;
};

// Account last active api ---------------

export const markRecentAccountActive = async (account_id) => {
  const res = await AspApi.put(
    `api/v1/accounts/${account_id}/mark_recent_active`,
  );
  return res;
};

export const markRecentActive = async (brandId, accountId) => {
  const res = await AspApi.put(
    `api/v1/brands/${brandId}/mark_recent_active?account_id=${accountId}`,
  );
  return res;
};

// Profile Info api ----------------
export const profileInformationApi = async (user_id) => {
  const res = await AspApi.get(`api/v1/svc/aaa/users/${user_id}`);
  return res;
};

export const profileInformationUpdate = async (user_id, payload) => {
  const res = await AspApi.put(`api/v1/svc/aaa/users/${user_id}`, payload);
  return res;
};

export const resetPasswordPatch = async (user_id, payload) => {
  const res = await AspApi.patch(
    `api/v1/svc/aaa/users/${user_id}/reset_password`,
    payload,
  );
  return res;
};

//account info api
export const accountInformationApi = async (accountId) => {
  const res = await AspApi.get(`api/v1/accounts/${accountId}`);
  return res;
};

export const accountInformationUpdate = async (accountId, payload) => {
  const res = await AspApi.put(`api/v1/accounts/${accountId}`, payload);
  return res;
};

export const accountInformationOtp = async (accountId, payload) => {
  const res = await AspApi.post(
    `api/v1/account_center/sent_whatsapp_otp?account_id=${accountId}`,
    payload,
  );
  return res;
};

export const accountOwnersInfoApi = async (accountId) => {
  const res = await AspApi.get(`api/v1/accounts/${accountId}/accounts_owners`);
  return res;
};

export const accountContactInfoApi = async (accountId) => {
  const res = await AspApi.get(
    `api/v1/accounts/${accountId}/contact_information`,
  );
  return res;
};

export const accountContactInformationUpdate = async (accountId, payload) => {
  const res = await AspApi.put(
    `api/v1/accounts/${accountId}/update_contact_information`,
    payload,
  );
  return res;
};

// Credits api

export const creditsApi = async (brand_id, params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const url = queryParams
    ? `api/v1/brands/${brand_id}/get_brand_credits?${queryParams}`
    : `api/v1/brands/${brand_id}/get_brand_credits`;
  const res = await AspApi.get(url);
  return res;
};

// brand message limit api
export const brandMessageLimitApi = async (brand_id, planType) => {
  const res = await AspApi.get(
    `api/v1/brands/${brand_id}/billing_plan_details?plan_type=${planType}`,
  );
  return res;
};

// billing plan pricing api
export const billingPlanPricingApi = async (brand_id) => {
  const res = await AspApi.get(
    `api/v1/brands/${brand_id}/billing_plan_pricing`,
  );
  return res;
};
